import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../../app/config";
import { axiosApiInstance } from "../../../app/axios";
import { ErrorToast, SuccessToast } from "../../../components/toast/Toasts";
import { IOpening } from "../openingsModal";

export const getAllOpening = createAsyncThunk(
  "JobOpening/FindAllJobOpening",
  async () => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/JobOpening/FindAllJobOpening`,
        {}
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Opening:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const createOpening = createAsyncThunk(
  "JobOpening/InsertJobOpening",
  async (OpeningData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/JobOpening/InsertJobOpening`,
        OpeningData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error creating Opening:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const updateOpening = createAsyncThunk(
  "JobOpening/UpdateJobOpening",
  async (OpeningData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/JobOpening/UpdateJobOpening`,
        OpeningData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error updating Opening :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const deleteOpening = createAsyncThunk(
  "JobOpening/DeleteJobOpening",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/JobOpening/DeleteJobOpening`,
        { ID }
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error deleting Opening :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getOpeningByID = createAsyncThunk(
  "JobOpening/FindByIDJobOpening",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/JobOpening/FindByIDJobOpening`,
        { ID }
      );
      const result = response.data?.Data as any;
      return {
        ID: result.ID,
        Profile: result?.Profile ?? "",
        Positions: result?.Positions ?? 0,
        Experience: result?.Experience ?? 0,
        Location: result?.Location ?? "",
        Eligibility: result?.Eligibility ?? "",
        Summary: result?.Summary ?? "",
        Responsibilities: result?.Responsibilities ?? "",
        IsActive: result.IsActive ? 1 : 2,
      } as IOpening;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error fetching Opening :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getAllActiveOpening = createAsyncThunk(
  "JobOpening/FindAllActiveJobOpening",
  async () => {
    try {
      const response = await axiosApiInstance.get(
        `${API_URL}/JobOpening/FindAllActiveJobOpening`
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Openinges:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const ActiveInactiveOpening = createAsyncThunk(
  "JobOpening/ActiveInActiveJobOpening",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/JobOpening/ActiveInActiveJobOpening`,
        formData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error active-inactive Opening :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);
